import { createContext, useContext } from "react";

import type { MedicalScribeRecordingContextType } from "./medical-scribe-context-type.type";

export const MedicalScribeRecordingContext =
  createContext<MedicalScribeRecordingContextType | null>(null);

/**
 * ENG-2089: the recording engine is a lazy SIBLING of the app, not a wrapper around it, so an
 * eligible user can render a consumer before the engine's chunk has loaded. While it loads the
 * shell provides a promise here and consumers suspend on it; if the chunk failed, it provides
 * the error. `null` means the user is not eligible and there is no engine to wait for.
 */
export const MedicalScribeRecordingPendingContext = createContext<
  Promise<void> | Error | null
>(null);

export function useMedicalScribeRecording(): MedicalScribeRecordingContextType {
  const context = useContext(MedicalScribeRecordingContext);
  const pending = useContext(MedicalScribeRecordingPendingContext);
  if (context) return context;
  if (pending) throw pending; // a promise suspends; an Error reaches the nearest error boundary
  throw new Error(
    "useMedicalScribeRecording must be used within a MedicalScribeRecordingProvider (i.e. the user must be eligible — check isMedicalScribeEnabled before calling)"
  );
}
